var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSodDownloadStatic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "160px",
    viewBox: "0 0 240 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SOD_Download_newStatic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SOD_Download_newStatic"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lv2_Icon_Frame_rest"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Frame_rest"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D9E8F6",
    x: 0,
    y: 0,
    width: 240,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FFFFFF",
    x: 8,
    y: 8,
    width: 224,
    height: 144
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M94,102 L94,81 L146,81 L146,102 L178,102 L120,160 L62,102 L94,102 Z",
    id: "Combined-Shape",
    fill: "#B49859"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(29.000000, 13.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(83.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(104.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(146.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(0.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(41.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(125.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(167.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(62.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(0.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(62.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(83.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(146.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(167.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(41.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(104.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(125.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-2",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(62.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(83.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(104.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_checked",
    transform: "translate(146.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1A4480",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 3.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48528137,9.48528137 L16.9852814,9.48528137 C17.8137085,9.48528137 18.4852814,10.1568542 18.4852814,10.9852814 L18.4852814,11.9852814 C18.4852814,12.8137085 17.8137085,13.4852814 16.9852814,13.4852814 L3.98528137,13.4852814 C3.15685425,13.4852814 2.48528137,12.8137085 2.48528137,11.9852814 L2.48528137,4.98528137 C2.48528137,4.15685425 3.15685425,3.48528137 3.98528137,3.48528137 L4.98528137,3.48528137 C5.8137085,3.48528137 6.48528137,4.15685425 6.48528137,4.98528137 L6.48528137,9.48528137 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#1A4480",
    transform: "translate(10.485281, 8.485281) rotate(-45.000000) translate(-10.485281, -8.485281) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(41.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(125.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_uncheck",
    transform: "translate(167.000000, 3.000000)",
    fill: "#FFFFFF",
    stroke: "#1A4480",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    rx: 2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSodDownloadStatic);
export default __webpack_public_path__ + "static/media/SOD_Download_Static.5f3212d7e47797a2ff17936f4c3a7d53.svg";
export { ForwardRef as ReactComponent };